import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Defers a map-listing refresh requested while an animated listing action flow
 * still covers the map. Closing a flow by itself does not request a refresh.
 */
export const useDeferredMapListingsRefresh = (blocked: boolean) => {
  const blockedRef = useRef(blocked);
  const pendingRef = useRef(false);
  const [releaseRevision, setReleaseRevision] = useState(0);

  blockedRef.current = blocked;

  const deferIfBlocked = useCallback(() => {
    if (!blockedRef.current) return false;
    pendingRef.current = true;
    return true;
  }, []);

  useEffect(() => {
    if (blocked || !pendingRef.current) return;
    pendingRef.current = false;
    setReleaseRevision((revision) => revision + 1);
  }, [blocked]);

  return { deferIfBlocked, releaseRevision };
};
